import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config/config.service';
import { firstValueFrom } from 'rxjs';
import { Constants } from '../constants';
import { Claim } from 'src/app/services/accounts/accounts.model';
import { ResponseInterface } from '../interfaces/response.interface';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  /**
   * Holds the actual data of the personal info form submitted to the registration API
   */
  public readonly personalInfo = signal<Record<string, string>>(undefined);

  public readonly personalInfoCache = signal<Record<string, string>>(undefined);

  public readonly personalInfoConsents = signal<number[]>(undefined);

  public readonly registeredUserData = signal<{ synlabId: string; userId: string }>(undefined);

  /**
   * Holds the actual data of the complete details form submitted to the registration API
   */
  public readonly completeDetails = signal<Record<string, string>>(undefined);

  public readonly completeDetailsCache = signal<Record<string, string>>(undefined);

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {}

  public registerCustomer(
    email: string,
    password: string,
    consents: number[],
    italian: boolean,
    fiscalCode: string = null,
  ) {
    const { BaseAuthUrl } = this.configService.envConfig;
    const request = this.http.post<ResponseInterface<{ synlabId: string; userId: string }>>(
      `${BaseAuthUrl}${Constants.signUpUrl}`,
      {
        EmailAddress: email,
        Consents: consents.join(','),
        Password: password,
        FiscalCode: fiscalCode,
        Italian: italian,
      },
    );
    return firstValueFrom(request);
  }

  public get isItalian() {
    const personalInfo = this.personalInfo();
    const isItalian = personalInfo
      ? !personalInfo?.noFiscalCode
      : !this.personalInfoCache()?.noFiscalCode;
    return Boolean(isItalian);
  }

  public async completeProfile(id: string, claims: Claim[]) {
    const { BaseAuthUrl } = this.configService.envConfig;
    const request = this.http.put(`${BaseAuthUrl}${Constants.completeProfileUrl}`, claims, {
      params: { id },
    });
    return firstValueFrom(request);
  }
}
